/**
   * SmoothScroll - executes a smooth page scroll to the given selector
   * @param {string} selector - a querySelector e.g. #foobar
   * @param {string} fallback - top or bottom (default false). The fallback scroll destination
   */
export default function SmoothScroll(selector, fallback = false) {
  if (typeof selector !== 'undefined' && selector) {
    const exists = !!document.querySelector(selector);
    if (exists) {
      document.querySelector(selector).scrollIntoView({
        behavior: 'smooth',
      });
      return;
    }
  }

  if (fallback === 'top') {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  } else if (fallback === 'bottom') {
    window.scrollTo({
      left: 0,
      top: document.body.scrollHeight,
      behavior: 'smooth',
    });
  }
}
